import Component from 'components/pages/SurveyTips/SurveyTips.qmee';
import { buildPage, buildStaticProps } from 'utils/pageHelper';
import SURVEY_TIPS from 'constants/QmeeSurveyTips';

export default buildPage(Component, {
  requiresAuthentication: false,
  metaData: {
    title: 'Survey Tips',
    description: 'Survey Tips Page',
  },
});

export const getStaticProps = async (
  context: Parameters<ReturnType<typeof buildStaticProps>>[0],
) => {
  const base = await buildStaticProps('survey-tips', {
    withoutHeaderOnMobile: true,
    withoutFooterOnMobile: true,
  })(context);
  return {
    ...base,
    props: {
      ...(base as { props: object }).props,
      surveyTips: SURVEY_TIPS,
    },
  };
};
